import * as React from "react";
import * as styles from "./pictBlock.module.scss";

export default function PictBlock({src}) {
  return (
    <div className={styles.wrap}>
      <img className={styles.pict} src={src} alt={''}/>
    </div>
  )
}